import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import * as PropTypes from 'prop-types';
import { optionalUrlParams } from 'utils/common';
import { getContainerWideSelector } from 'common/selectors/index';
import { collectionCurrentPageSelector, collectionVideosSelector } from 'common/selectors/collection';
import { urlVideoIdSelector } from 'pages/channel.page/index';
import { urlSortSelector } from 'common/selectors/router';
import { VideoItem } from 'components/video-item/index';

const VideoList = (props) =>
  !props.videos ? null : (
    <div className="ct-video-list" data-e2e="video-list">
      <div className="ct-video-list__videos">
        {props.videos &&
          props.videos.map((video) => (
            <div
              key={video.id}
              data-e2e="videoListItem"
              className={`ct-video-list__elem${props.containerWide ? ' ct-video-list__elem--container-wide' : ''}`}
            >
              <VideoItem
                key={video.id}
                video={video}
                pageNumber={props.pageNumber}
                sort={props.sort}
                url={`${props.baseUrl}/${props.currentPageNum}/${video.id}${optionalUrlParams({ sort: props.sort })}`}
                maskJSX={props.maskJSX}
                showRating
                contextMenu={props.contextMenu}
              />
            </div>
          ))}
      </div>
    </div>
  );

export const VideoListDecorated = compose(
  withRouter,
  connect((state, props) => ({
    containerWide: getContainerWideSelector(state),
    currentPageNum: collectionCurrentPageSelector(state),
    videos: collectionVideosSelector(state),
    videoId: urlVideoIdSelector(state, props.match),
    sort: urlSortSelector(state, props.match),
  }))
)(VideoList);

VideoListDecorated.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  maskJSX: PropTypes.func,
  contextMenu: PropTypes.func,
};
